<div [formGroup]="issqnForm">

    <app-ativacao-section-card
        [control]="isAtivoControl"
        titulo="ISSQN"
        descricaoAtivo="ISSQN ativo. A regra padrão e as exceções abaixo serão aplicadas no cálculo desta natureza de operação."
        descricaoInativo="ISSQN inativo. Nenhum valor de ISSQN será calculado nesta natureza de operação."
        emptyStateDescricao="Ative o ISSQN acima para configurar a regra padrão, as observações e as exceções deste tributo.">
    </app-ativacao-section-card>

    @if (isAtivoControl.value) {

    <!-- ── Regra Padrão ──────────────────────────────────────────────── -->
    <app-issqn-tributo-regra-section
        [form]="issqnForm"
        [codigoTributos]="codigoTributos"
        [tipoOperacao]="tipoOperacaoValue"
        [modalidadesBcSt]="modalidadesBcSt"
        [indicadoresIncentivo]="indicadoresIncentivoFiscalIssqn"
        [personalizadasCount]="personalizadasCount"
        [personalizarDisabled]="formulasParaCodigoTributo.length === 0"
        (personalizar)="abrirEditorFormulas()">
    </app-issqn-tributo-regra-section>

    <!-- ── Observações ────────────────────────────────────────────────── -->
    <app-issqn-tributo-observacoes-section
        [control]="$any(issqnForm.get('observacao'))"
        [variaveis]="issqnForm.get('indicadorIss')?.value ? variaveisUnicas : []"
        titulo="Informações complementares"
        icone="notes"
        placeholder="Texto da observação que será impresso no documento fiscal..."
        (abrirVariaveis)="abrirVariaveisDisponiveis($event)">
    </app-issqn-tributo-observacoes-section>

    <!-- ── Informações adicionais ao fisco ───────────────────────────────────────── -->
    <app-issqn-tributo-observacoes-fisco-section
        [control]="$any(issqnForm.get('observacaoFisco'))"
        [variaveis]="issqnForm.get('indicadorIss')?.value ? variaveisUnicas : []"
        (abrirVariaveis)="abrirVariaveisDisponiveis($event)">
    </app-issqn-tributo-observacoes-fisco-section>

    <!-- ── Exceções ───────────────────────────────────────────────────── -->
    <app-issqn-tributo-excecoes-section
        [idNaturezaOperacao]="idNaturezaOperacao"
        [codigoTributos]="codigoTributos"
        [modalidadesBcSt]="modalidadesBcSt"
        [indicadoresIncentivo]="indicadoresIncentivoFiscalIssqn"
        [variaveis]="variaveisUnicas"
        [formulasIssqn]="formulasIssqn"
        [tipoOperacao]="tipoOperacaoValue"
        [excecoesPendentes]="excecoesPendentes"
        (excecoesChange)="excecoesChange.emit($event)">
    </app-issqn-tributo-excecoes-section>

    }

</div>
